import React from "react";
import ContentLoader from "react-content-loader";

const LineLoader = (props: ILineLoader) => (
  <ContentLoader
    height={props.canvasHeight ? props.canvasHeight : 40}
    width={props.canvasWidth ? props.canvasWidth : 50}
    speed={props.speed ? props.speed : 2}
  >
    <rect
      x={props.linePositionX ? props.linePositionX : "0"}
      y={props.linePositionY ? props.linePositionY : "0"}
      rx="0"
      ry="0"
      width={props.lineWidth ? props.lineWidth : "10"}
      height={props.lineHeight ? props.lineHeight : "5"}
    />
  </ContentLoader>
);

export default LineLoader;

interface ILineLoader {
  canvasHeight?: number;
  canvasWidth?: number;
  speed?: number;
  linePositionX?: string;
  linePositionY?: string;
  lineWidth?: string;
  lineHeight?: string;
}
